import { render } from "./poll-v1.vue?vue&type=template&id=1d1b8a76"
import script from "./poll-v1.vue?vue&type=script&lang=js"
export * from "./poll-v1.vue?vue&type=script&lang=js"

import "./poll-v1.vue?vue&type=style&index=0&id=1d1b8a76&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__